/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  LoadoutSlotList,
  PublicVehicleLoadoutParams,
  PublicVehicleLoadoutSlotsParams,
  SchemaValidationErrorResponse,
  StandardError,
  VehicleLoadout
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Public Vehicle Loadout
 */
export const publicVehicleLoadout = (
    username: MaybeRefOrGetter<string>,
    vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicVehicleLoadoutParams>,
 signal?: AbortSignal
) => {
      username = toValue(username);
vehicleId = toValue(vehicleId);
id = toValue(id);
params = toValue(params);

      return axiosClient<VehicleLoadout>(
      {url: `/public/hangars/${username}/vehicles/${vehicleId}/loadouts/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getPublicVehicleLoadoutQueryKey = (username: MaybeRefOrGetter<string>,
    vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicVehicleLoadoutParams>,) => {
    return [
    'public','hangars',username,'vehicles',vehicleId,'loadouts',id, ...(params ? [params] : [])
    ] as const;
    }


export const getPublicVehicleLoadoutQueryOptions = <TData = Awaited<ReturnType<typeof publicVehicleLoadout>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(username: MaybeRefOrGetter<string>,
    vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicVehicleLoadoutParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicVehicleLoadout>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicVehicleLoadoutQueryKey(username,vehicleId,id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicVehicleLoadout>>> = ({ signal }) => publicVehicleLoadout(username,vehicleId,id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(username) !== null && toValue(username) !== undefined && toValue(vehicleId) !== null && toValue(vehicleId) !== undefined && toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicVehicleLoadout>>, TError, TData>
}

export type PublicVehicleLoadoutQueryResult = NonNullable<Awaited<ReturnType<typeof publicVehicleLoadout>>>
export type PublicVehicleLoadoutQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Vehicle Loadout
 */

export function usePublicVehicleLoadout<TData = Awaited<ReturnType<typeof publicVehicleLoadout>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 username: MaybeRefOrGetter<string>,
    vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicVehicleLoadoutParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicVehicleLoadout>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicVehicleLoadoutQueryOptions(username,vehicleId,id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Public Vehicle Loadout Slots
 */
export const publicVehicleLoadoutSlots = (
    username: MaybeRefOrGetter<string>,
    vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicVehicleLoadoutSlotsParams>,
 signal?: AbortSignal
) => {
      username = toValue(username);
vehicleId = toValue(vehicleId);
id = toValue(id);
params = toValue(params);

      return axiosClient<LoadoutSlotList>(
      {url: `/public/hangars/${username}/vehicles/${vehicleId}/loadouts/${id}/slots`, method: 'GET',
        params, signal
    },
      );
    }




export const getPublicVehicleLoadoutSlotsQueryKey = (username: MaybeRefOrGetter<string>,
    vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicVehicleLoadoutSlotsParams>,) => {
    return [
    'public','hangars',username,'vehicles',vehicleId,'loadouts',id,'slots', ...(params ? [params] : [])
    ] as const;
    }


export const getPublicVehicleLoadoutSlotsQueryOptions = <TData = Awaited<ReturnType<typeof publicVehicleLoadoutSlots>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(username: MaybeRefOrGetter<string>,
    vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicVehicleLoadoutSlotsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicVehicleLoadoutSlots>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicVehicleLoadoutSlotsQueryKey(username,vehicleId,id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicVehicleLoadoutSlots>>> = ({ signal }) => publicVehicleLoadoutSlots(username,vehicleId,id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(username) !== null && toValue(username) !== undefined && toValue(vehicleId) !== null && toValue(vehicleId) !== undefined && toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicVehicleLoadoutSlots>>, TError, TData>
}

export type PublicVehicleLoadoutSlotsQueryResult = NonNullable<Awaited<ReturnType<typeof publicVehicleLoadoutSlots>>>
export type PublicVehicleLoadoutSlotsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Vehicle Loadout Slots
 */

export function usePublicVehicleLoadoutSlots<TData = Awaited<ReturnType<typeof publicVehicleLoadoutSlots>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 username: MaybeRefOrGetter<string>,
    vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicVehicleLoadoutSlotsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicVehicleLoadoutSlots>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicVehicleLoadoutSlotsQueryOptions(username,vehicleId,id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






